import * as React from 'react';
import { useDispatch } from 'react-redux';
import { fetchApi, makeResetCache, notifyError, notifyResponse, RecordPicker } from 'gossamer-front-end';
import { InstitutionGroup, InstitutionGroupMember } from 'cb-model';
import { Button, InputGroup } from 'react-bootstrap';
import { FieldType, getFilter } from 'gossamer-unified';
import { institutionButton } from 'packages/shared-front-end/header/header.module.css';

export interface AddMemberToGroupButtonProps {
  emailAddress: string;
  institutionId: number;
}

export const AddMemberToGroupButton: React.FC<AddMemberToGroupButtonProps> = (props) => {
  const [groupId, setGroupId] = React.useState<string | null>(null);
  const dispatch = useDispatch();
  const resetCache = makeResetCache(dispatch);

  const handleClick = async () => {
    try {
      const response = await fetchApi('POST', `/main/institution-group-member-add`, {
        invites: [{ emailAddress: props.emailAddress, addToInstitutionGroupIds: [parseInt(groupId, 10)] }],
        institutionId: props.institutionId,
      });
      resetCache(InstitutionGroupMember.id);
      setGroupId(null);
      notifyResponse(response);
    } catch (e) {
      notifyError(e, 'An error occurred while adding the member to the group');
    }
  };
  return (
    <InputGroup>
      <InputGroup.Text>Add this Member to a Group</InputGroup.Text>
      <RecordPicker
        editable={true}
        onItemSelected={setGroupId}
        value={groupId}
        field={{
          seq: 0,
          type: FieldType.Reference,
          label: 'Group',
          refEntity: InstitutionGroup,
        }}
        queryOptions={{
          where: {
            and: [getFilter('title', 'ct', ''), getFilter('institution_id', 'eq', props.institutionId, 'hidden')],
          },
          order: [['title', 'ASC']],
        }}
      />
      <Button size="sm" variant="primary" disabled={!groupId} onClick={handleClick}>
        Add
      </Button>
    </InputGroup>
  );
};
